import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "global-container" }
const _hoisted_3 = { class: "contents-container" }
const _hoisted_4 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_5 = {
  style: { alignContent: 'center', width: '40vw', maxWidth: '100vw' },
  class: "text-h5 mt-2"
}
const _hoisted_6 = {
  key: 0,
  class: "mt-2 text-caption gray-text"
}
const _hoisted_7 = { class: "font-weight-medium" }
const _hoisted_8 = {
  key: 0,
  class: "mt-2 text-caption gray-text"
}
const _hoisted_9 = { style: {"display":"flex","align-items":"center","justify-content":"space-between","width":"100%"} }
const _hoisted_10 = {
  class: "rounded-xl pa-2",
  style: {"max-width":"70%","word-break":"break-word","white-space":"pre-wrap","backdrop-filter":"blur(5px)"}
}
const _hoisted_11 = {
  key: 0,
  class: "mt-2 text-caption",
  style: {"color":"gray"}
}

import HeaderComponent from '@/components/home/HeaderComponent.vue'
import { firestore as db, storage } from '@/main'
import { Download } from '@/types/Download'
import { useRouter } from 'vue-router'
import { deleteDoc, doc, getDocs, query, orderBy, collection } from 'firebase/firestore'
import { ref as storageRef, deleteObject } from 'firebase/storage'
import { onMounted, ref, watch } from 'vue'
import { Delta } from '@vueup/vue-quill'
import { useAuthStore } from '@/stores/AuthStateStore'
import { storeToRefs } from 'pinia'

import CommonProgress from '@/components/common/CommonProgress.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DownloadsView',
  setup(__props) {

const router = useRouter()
const isLoading = ref(true)
const searchText = ref('')
const downloadsList = ref<Download[]>([])
const filteredList = ref<Download[]>([])
const selectedItem = ref<Download | null>(null)
const showWindow = ref(false)
const { isSignedIn, isAdmin } = storeToRefs(useAuthStore())

function isExpandedAll () {
  return filteredList.value.every(item => item.showContents)
}

function expandAll () {
  const expand = !isExpandedAll()
  filteredList.value.forEach(item => {
    item.showContents = expand
  })
}

function deleteItem (item: Download) {
  if (confirm(`Are you sure you want to delete post ${item.title}?\nThis action cannot be undone.`)) {
    showWindow.value = false
    isLoading.value = true

    deleteDoc(doc(db, item.isPrivate ? 'Private_Downloads' : 'Downloads', item.id as string))
      .then(() => {
        if (item.file !== '' && item.file !== undefined && item.file !== null) {
          deleteObject(storageRef(storage, item.isPrivate ? `private_downloads/${decodeURIComponent(item.file.split('downloads%2F').pop()?.split('?')[0] ?? '')}` : `downloads/${decodeURIComponent(item.file.split('downloads%2F').pop()?.split('?')[0] ?? '')}`))
            .catch((e: Error) => {
              alert(`An error occurred while deleting file.\nPlease try again later.\n(${e.message})`)
            })
            .finally(() => {
              alert('Post deleted successfully.')
              downloadsList.value = downloadsList.value.filter(i => i.id !== item.id)
              filteredList.value = filteredList.value.filter(i => i.id !== item.id)
              isLoading.value = false
            })
        } else {
          alert('Post deleted successfully.')
          downloadsList.value = downloadsList.value.filter(i => i.id !== item.id)
          filteredList.value = filteredList.value.filter(i => i.id !== item.id)
          isLoading.value = false
        }
      })
      .catch((e: Error) => {
        alert(`An error occurred while deleting post.\nPlease try again later.\n(${e.message})`)
        isLoading.value = false
      })
  }
}

function getPrivateDownloads () {
  getDocs(query(collection(db, 'Private_Downloads'), orderBy('date', 'desc')))
    .then((querySnapshot) => {
      const newPrivateDownloads = querySnapshot.docs.map((doc) => ({
        ...(doc.data() as Download),
        id: doc.id,
        contentsDelta: doc.data().contents === '' || doc.data().contents === undefined ? undefined : new Delta(JSON.parse(doc.data().contents || '{}')),
        showContents: false,
        isPrivate: true
      }))

      removePrivateDownloads()
      downloadsList.value.push(...newPrivateDownloads)
      downloadsList.value.sort((a, b) => (a.date < b.date ? 1 : -1))
    })
    .catch((e: Error) => {
      console.log(e.message)
    })
    .finally(() => {
      downloadsList.value = Array.from(new Set(downloadsList.value))
      filteredList.value = downloadsList.value
      isLoading.value = false
    })
}

function removePrivateDownloads () {
  downloadsList.value = downloadsList.value.filter(item => !item.isPrivate)
  filteredList.value = filteredList.value.filter(item => !item.isPrivate)
}

onMounted(() => {
  downloadsList.value = []
  filteredList.value = []

  getDocs(query(collection(db, 'Downloads'), orderBy('date', 'desc')))
    .then((querySnapshot) => {
      downloadsList.value = querySnapshot.docs.map((doc) => ({
        ...(doc.data() as Download),
        id: doc.id,
        contentsDelta: doc.data().contents === '' || doc.data().contents === undefined ? undefined : new Delta(JSON.parse(doc.data().contents || '{}')),
        showContents: false,
        isPrivate: false
      }))

      filteredList.value = downloadsList.value

      if (isSignedIn.value) {
        getPrivateDownloads()
      }
    })
    .catch((e: Error) => {
      console.log(e.message)
    })
    .finally(() => {
      if (!isSignedIn.value) {
        isLoading.value = false
      }
    })
})

watch(() => isSignedIn.value, () => {
  if (isSignedIn.value) {
    getPrivateDownloads()
  } else {
    removePrivateDownloads()
  }
})

watch(searchText, () => {
  if (searchText.value === '') {
    filteredList.value = downloadsList.value
  } else {
    filteredList.value = downloadsList.value.filter(download => download.title.toLowerCase().includes(searchText.value.toLowerCase()) || (download.contents !== undefined && download.contents.toLowerCase().includes(searchText.value.toLowerCase())))
  }
})

watch(showWindow, () => {
  if (!showWindow.value) {
    selectedItem.value = null
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createVNode(HeaderComponent, {
              title: 'Downloads',
              "show-secondary-trailing-btn": true,
              "secondary-trailing-icon": isExpandedAll() ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down',
              onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/create-post'))),
              onOnSecondaryBtnClick: _cache[1] || (_cache[1] = ($event: any) => (expandAll()))
            }, null, 8, ["secondary-trailing-icon"])
          ]),
          _createVNode(_component_v_text_field, {
            class: "mt-5 search-bar",
            modelValue: searchText.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchText).value = $event)),
            label: "Search Downloads",
            color: "primary",
            "prepend-inner-icon": "mdi-magnify",
            variant: "outlined",
            "clear-icon": "mdi-close",
            clearable: "",
            "onClick:clear": _cache[3] || (_cache[3] = ($event: any) => (searchText.value = ''))
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_3, [
            (isLoading.value)
              ? (_openBlock(), _createBlock(CommonProgress, { key: 0 }))
              : (!isLoading.value && filteredList.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-xmark" }),
                    _createTextVNode(" " + _toDisplayString(_unref(isSignedIn) ? 'No posts found' : 'No posts found. Some posts are only visible when you are signed in.'), 1)
                  ]))
                : (_openBlock(), _createBlock(_component_v_row, { key: 2 }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredList.value, (item) => {
                        return (_openBlock(), _createBlock(_component_v_col, {
                          xs: "12",
                          sm: "12",
                          md: "6",
                          lg: "4",
                          xl: "3",
                          xxl: "3",
                          class: "mt-5",
                          key: item.id
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createVNode(_component_v_card, {
                                class: "rounded-xl",
                                variant: "outlined"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_title, {
                                    class: "text-h4 font-weight-medium mt-2",
                                    style: {"word-break":"break-word","white-space":"normal"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_card_subtitle, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.date) + " ", 1),
                                      (item.isPrivate && !item.showContents)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-eye-slash" }),
                                            _cache[9] || (_cache[9] = _createTextVNode(" Private ", -1))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (item.showContents)
                                    ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1),
                                          _createVNode(_component_QuillEditor, {
                                            class: "mt-2",
                                            content: item.contentsDelta,
                                            "onUpdate:content": ($event: any) => ((item.contentsDelta) = $event),
                                            options: { readOnly: true, theme: 'bubble', modules: { toolbar: false } }
                                          }, null, 8, ["content", "onUpdate:content"]),
                                          (item.isPrivate)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-eye-slash" }),
                                                _cache[10] || (_cache[10] = _createTextVNode(" This is a private post, only visible to signed-in users. ", -1))
                                              ]))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_v_btn, {
                                            class: "mt-2 button",
                                            variant: "tonal",
                                            href: item.file
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-download" }),
                                              _createTextVNode(" " + _toDisplayString(decodeURIComponent(item.file.split('%2F').pop()?.split('?')[0] ?? 'Download')), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["href"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_v_card_actions, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        onClick: ($event: any) => (item.showContents = !item.showContents),
                                        variant: "text"
                                      }, {
                                        default: _withCtx(() => [
                                          (!item.showContents)
                                            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                                key: 0,
                                                icon: "fa-solid fa-chevron-down"
                                              }))
                                            : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                                key: 1,
                                                icon: "fa-solid fa-chevron-up"
                                              }))
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]),
                                      _createVNode(_component_v_btn, {
                                        variant: "text",
                                        onClick: ($event: any) => {{
                      selectedItem.value = item;
                      showWindow.value = true;
                    }}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-window-maximize" })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]),
                                      (_unref(isSignedIn) && _unref(isAdmin))
                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 0,
                                            onClick: ($event: any) => (_unref(router).push({
                        name: 'modifyPost',
                        state: {
                          post: {
                            id: item.id,
                            contents: item.contents,
                            title: item.title,
                            date: item.date,
                            category: item.isPrivate ? 'Private_Downloads' : 'Downloads',
                          }
                        }
                      }))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-edit" })
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        : _createCommentVNode("", true),
                                      (_unref(isSignedIn) && _unref(isAdmin))
                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 1,
                                            color: "red",
                                            onClick: ($event: any) => (deleteItem(item))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-trash" })
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }))
          ])
        ]),
        (showWindow.value && selectedItem.value !== null)
          ? (_openBlock(), _createBlock(_component_v_dialog, {
              key: 0,
              modelValue: showWindow.value,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showWindow).value = $event)),
              style: {"backdrop-filter":"blur(5px)"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, { class: "pa-5" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, {
                      class: "rounded-xl",
                      style: {"word-break":"break-word","white-space":"pre-wrap","position":"sticky","top":"0","background-color":"transparent","backdrop-filter":"blur(5px)","z-index":"1000"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, _toDisplayString(selectedItem.value.title), 1),
                          _createVNode(_component_v_btn, {
                            style: {"margin-left":"16px","flex-shrink":"0"},
                            color: "red",
                            variant: "tonal",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => {selectedItem.value = null; showWindow.value = false;})
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-xmark" })
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_subtitle, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(selectedItem.value.date), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_QuillEditor, {
                          class: "mt-2",
                          content: selectedItem.value.contentsDelta,
                          "onUpdate:content": _cache[5] || (_cache[5] = ($event: any) => ((selectedItem.value.contentsDelta) = $event)),
                          options: { readOnly: true, theme: 'bubble', modules: { toolbar: false } }
                        }, null, 8, ["content"]),
                        _createVNode(_component_v_btn, {
                          class: "mt-2",
                          variant: "tonal",
                          href: selectedItem.value.file,
                          style: {"text-transform":"unset"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-download" }),
                            _createTextVNode(" " + _toDisplayString(decodeURIComponent(selectedItem.value.file.split('%2F').pop()?.split('?')[0] ?? 'Download')), 1)
                          ]),
                          _: 1
                        }, 8, ["href"]),
                        (selectedItem.value.isPrivate)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-eye-slash" }),
                              _cache[11] || (_cache[11] = _createTextVNode(" This is a private post, only visible to signed-in users. ", -1))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_actions, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_spacer),
                        (_unref(isSignedIn) && _unref(isAdmin))
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              onClick: _cache[6] || (_cache[6] = ($event: any) => {{
              showWindow.value = false;
              _unref(router).push({
                name: 'modifyPost',
                state: {
                  post: {
                    id: selectedItem.value.id,
                    contents: selectedItem.value.contents,
                    title: selectedItem.value.title,
                    date: selectedItem.value.date,
                    category: selectedItem.value.isPrivate ? 'Private_Downloads' : 'Downloads',
                  }
                }
              });
            }})
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-edit" })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_unref(isSignedIn) && _unref(isAdmin))
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 1,
                              color: "red",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (deleteItem(selectedItem.value)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-trash" })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})